

import React, { useState } from 'react';
import event from "../../main_assets/Event.png";
import evet from "../../main_assets/evet.png";
import pastEventImg from "../../main_assets/pastEventImg.png";
import profile from "../../main_assets/profile.png";
import './register.css'

const Register = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // if (loading)
  //   return (
  //     <div className="loading-container">
  //       <div className="spinner"></div>
  //       <p>Loading issues...</p>
  //     </div>
  //   );
  // if (error)
  //   return (
  //     <div className="error-container">
  //       <div className="error-icon">⚠️</div>
  //       <p>Error: {error}</p>
  //     </div>
  //   );

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-red-600"></div>
        <p className="ml-4 text-lg">Loading Register...</p>
      </div>
    );
  }
  

  return (
    <div className="contact section__padding">
      {/* Hero Section */}
      <div className="flex flex-col md:flex-row">
        {/* Left side - Event Image */}
        <div className="flex-1">
          <img
            src={event}
            alt="Conference audience"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Right side - Red Background with Event Details */}
        <div className="flex-1" style={{background: "#CD3333"}}>
          <div className="p-12 md:p-16 lg:p-24">
            <div className="max-w-xl">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-black mb-8" style={{fontFamily: "Poppins-SemiBold", lineHeight: "1"}}>
                Design and Connect conference 2024
              </h1>
              
              <div className="text-white text-xl md:text-2xl lg:text-3xl" style={{fontFamily: "Poppins-Light", lineHeight: "1.2"}}>
                Saturday October 2nd to Monday October 4th
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Content Section */}
      {/* <div className="py-16 px-8 md:px-16 lg:px-24"> */}
      <div className="section__paddingaaa">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Left Column */}
          <div>
            <p className="text-[#CD3333] mb-8" style={{fontFamily: "Poppins-Regular"}}>
              accumsan lacus vel facilisis. Lorem ipsum dolor sit amet,
              consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
              labore et dolore magna aliqua. Quis ipsum suspendisse ultricies
              gravida. Risus commodo viverra maecenas accumsan lacus vel
              facilisis. Lorem ipsum dolor sit amet, consectetur adipiscing elit,
              sed do eiusmod tempor incididunt ut
            </p>
            <p className="text-gray-700" style={{fontFamily: "Poppins-Light", fontSize: "14px"}}>
              labore et dolore magna aliqua. Quis ipsum suspendisse ultricies gravida. Risus commodo viverra
              maecenas accumsan lacus vel facilisis. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
              do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultricies
              gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis. Lorem ipsum dolor sit
              amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna
              aliqua. Quis ipsum suspendisse ultricies gravida. Risus commodo.
            </p>
          </div>

          {/* Right Column */}
          <div>
            <p className="text-gray-700" style={{fontFamily: "Poppins-Light", fontSize: "14px"}}>
              incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultricies gravida. Risus
              commodo viverra maecenas accumsan lacus vel facilisis. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultricies
              gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis. Lorem ipsum dolor sit
              amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna
              aliqua. Quis ipsum suspendisse ultricies gravida. Risus commodo viverra maecenas accumsan
              lacus vel facilisis. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
              incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultricies gravida. Risus
              commodo viverra maecenas accumsan lacus vel facilisis. Lorem ipsum dolor sit amet, consectetur
              adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum
              suspendisse ultricies gravida.
            </p>
          </div>
        </div>
      </div>

      <div className="section__paddingaa">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Left Column */}
          <div>
            {
              // the other section on the left
            }
          </div>

          {/* Right Column */}
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-[#CD3333] mb-12 text-left " style={{fontFamily: "Poppins-SemiBold"}}>
              Key speakers
            </h2>
            
            <div className="flex flex-wrap justify-start gap-8 md:gap-16">
              {[1, 2, 3].map((index) => (
                <div key={index} className="flex flex-col items-center">
                  <div className="w-40 h-40 rounded-full overflow-hidden mb-4">
                    <img
                      src={profile}
                      alt={`Speaker ${index}`}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <h3 className="text-xl font-semibold" style={{fontFamily: "Poppins-Medium"}}>
                    John Doe
                  </h3>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="section__paddingaaaa">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Left Column - Registration Form */}
          <div>
            {/* another empty section */}
          </div>

          {/* Right Column - Key Speakers */}
          <div>
            <div className="max-w-xl">
              <h2 className="text-xl md:text-2xl font-bold text-black mb-12" style={{fontFamily: "Poppins-Regular"}}>
                Enter your information below to register
              </h2>
              
              <form className="space-y-8">
                <div>
                  <label className="block text-xl mb-2" style={{fontFamily: "Poppins-Medium"}}>
                    Full name
                  </label>
                  <input
                    type="text"
                    className="w-full p-3"
                    style={{fontFamily: "Poppins-Light", backgroundColor: "transparent", border: "1px solid #000000"}}
                  />
                </div>
                
                <div>
                  <label className="block text-xl mb-2" style={{fontFamily: "Poppins-Medium"}}>
                    Email
                  </label>
                  <input
                    type="email"
                    className="w-full p-3"
                    style={{fontFamily: "Poppins-Light", backgroundColor: "transparent", border: "1px solid #000000"}}
                  />
                </div>

                <button
                  type="submit"
                  className="w-full bg-[#CD3333] text-white py-4 text-xl"
                  style={{fontFamily: "Poppins-Medium"}}
                >
                  Register
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;